var map = {
	"./ajax.jpg": "1eeb",
	"./borussia1.jpg": "c769",
	"./cantona.jpg": "20aa",
	"./celtic.jpg": "f84b",
	"./celtic2.jpg": "9ab5",
	"./celtic4.jpg": "1a49",
	"./france.jpg": "0fa2",
	"./hjk.jpg": "3b82",
	"./manutd.jpg": "5deb",
	"./milan.jpeg": "800c",
	"./samp1.png": "4503",
	"./spfclf.jpg": "3d72"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7c24";